import { render, staticRenderFns } from "./AvatarDisplay.vue?vue&type=template&id=075f3989&"
import script from "./AvatarDisplay.vue?vue&type=script&lang=js&"
export * from "./AvatarDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports